import type { ReactNode } from 'react';
import { cn } from './cn';

/** Espaçamento padrão de uma página dentro do layout, em largura total. */
export function Page({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-4 sm:p-6', className)}>{children}</div>;
}
